import { UserService } from '../services/userService/user.service';

export function appInitializer(userService: UserService) {
  return () =>
    new Promise<void>((resolve,reject) => {
      userService.getUserInfo().then((resp) => {
        userService.getRFIDSendCardInformation().then((resp) => {
          resolve();
          //reject();
        });
      });
    });
}

export function getRFIDSendCardInfoInitializer(userService: UserService) {
  return () => new Promise<void>((resolve,reject) => {userService.getRFIDSendCardInformation().then((resp) => {resolve()})});
}
